import React from 'react';
import { useTransferTransferTypeInputQuery } from '../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../dum';
import { TRANSFER_TYPE_ID } from '../transfer-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../helpers';

interface ITransferTypeInput {
    // Locked while editing: the server rejects a transfer-type change on an
    // existing transfer ("Cant change transfer type"), so the input mirrors that.
    disabled?: boolean;
}

export function TransferTypeInput({ disabled = false }: ITransferTypeInput) {
    const { data } = useTransferTransferTypeInputQuery();

    return (
        <RhSingleAutocomplete
            itemText={'name'}
            itemValue={'id'}
            name={TRANSFER_TYPE_ID}
            label={shortLabel(FIELD_LABELS.transfer_type_id)}
            options={data?.getTransferTypes || []}
            disabled={disabled}
        />
    );
}
